<div class="form-group">
  <!-- [ngClass]="{ 'mt-2': !title }" -->
  <!-- control label -->
  <label [for]="id" class="form-label" *ngIf="title" [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }">
    {{ title }}
    <span [ngClass]="{ 'astrix-red': isRequired, 'no-astrix': !isRequired }">
      *
    </span>
  </label>

  <!-- tags filed -->
  <ng-container *ngIf="isTagsFiled; else input">
    <div [translatable]="{
        transKey: isTagsFiled ? placeholderTranslationKey : '',
        modEnum: isTagsFiled ? placeholderTranslationModuleEnum : ''
      }">
      <div class="w-100 tags-container">
        <ul class="tags-list" *ngIf="tags?.length">
          <li class="tags-list-item" *ngFor="let tag of tags">
            <span class="tags-list-item-label">{{ tag }}</span>
            <span class="tags-list-item-remove" (click)="removeTag(tag)">
              ×
            </span>
          </li>
        </ul>

        <input type="text" [ngStyle]="style" [id]="id" [dir]="dir" [placeholder]="placeholder" [disabled]="disabled"
          (keyup.enter)="onEnterTag()" [(ngModel)]="tagVal" />
      </div>
    </div>
  </ng-container>

  <!-- text filed -->
  <ng-template #input>
    <div [translatable]="{
        transKey: !isLongText ? placeholderTranslationKey : '',
        modEnum: !isLongText ? placeholderTranslationModuleEnum : ''
      }">
      <input *ngIf="!isLongText; else longText" class="form-control w-100 test"
        [type]="isPassword ? 'password' : isNumber ? 'number' : 'text'" [min]="minValue || minValueNew" [max]="maxValue"
        [ngStyle]="style" [ngClass]="{ valid: control?.valid }" [id]="id" [dir]="dir" [placeholder]="placeholder"
        [disabled]="disabled" (keyup)="keyup()" (keyup.enter)="keyup()" (input)="change()" (blur)="focus()"
        [(ngModel)]="value" [step]="isNumber ? stepNumber : ''" [prefix]="prefix" [mask]="prefix ? '00 000 0000' : null"
        [dir]="prefix ? 'ltr' : ''" />
    </div>
  </ng-template>

  <!-- text area -->
  <ng-template #longText>
    <div [translatable]="{
        transKey: isLongText ? placeholderTranslationKey : '',
        modEnum: isLongText ? placeholderTranslationModuleEnum : ''
      }">
      <textarea class="form-control w-100" [ngClass]="{ valid: control?.valid }" [ngStyle]="style" [id]="id" [dir]="dir"
        [placeholder]="placeholder" [disabled]="disabled" (keyup)="keyup()" (keyup.enter)="keyup()" (input)="change()"
        (blur)="focus()" [(ngModel)]="value"></textarea>
    </div>
  </ng-template>
</div>
<ng-container *ngIf="!!showValidations">
  <app-validation *ngIf="(control?.touched || isSubmitted) && control?.invalid" [title]="title" [control]="control"
    [length]="length" [minLength]="minLength" [minValueNew]="minValueNew" [maxValueNew]="maxValueNew"
    [valideMax]="validMax" [minValue]="minValue" [maxValue]="maxValue" [maxLength]="maxLength"></app-validation>

  <!-- {{minValue}} -->
</ng-container>